var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import { usePopper } from "react-popper";
import { Menu, MenuAction, MenuItem, NavbarMenuItem, NavbarMenuLink, Tooltip, TooltipOnHover, } from "tombac";
import { GuideIcon } from "tombac-icons";
import useOutsideClick from "../../useOutsideClick";
import { useLegoland } from "../LegolandContext";
import { IconButton } from "./IconButton";
var className = "MoveNavbar__guide-options";
var ButtonWithMenu = function (_a) {
    var items = _a.items;
    var _b = __read(useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var _c = __read(useState(null), 2), referenceElement = _c[0], setReferenceElement = _c[1];
    var _d = __read(useState(null), 2), popperElement = _d[0], setPopperElement = _d[1];
    var _e = usePopper(referenceElement, popperElement, {
        modifiers: [{ name: "offset", options: { offset: [5, 5] } }],
    }), styles = _e.styles, attributes = _e.attributes;
    var ref = useRef(null);
    ref.current = referenceElement;
    useOutsideClick(ref, function () {
        if (isOpen)
            setIsOpen(false);
    });
    return (React.createElement(Tooltip, { content: "Guides", placement: "bottom", size: "s", variant: "inverted" }, function (tooltip) { return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { className: className, "$ml": "1sp", onClick: function () {
                setIsOpen(!isOpen);
                if (isOpen) {
                    tooltip.close();
                }
            }, onMouseEnter: function () { return !isOpen && tooltip.open(); }, onMouseLeave: tooltip.close, ref: function (el) {
                setReferenceElement(el);
                tooltip.ref(el);
            } },
            React.createElement(GuideIcon, null)),
        isOpen && (React.createElement(Menu, __assign({ ref: setPopperElement, style: styles.popper }, attributes.popper), items.map(function (item) { return (React.createElement(MenuItem, { key: item.label },
            React.createElement(MenuAction, __assign({}, item.props), item.label))); }))))); }));
};
export var GuideButton = function (_a) {
    var _b = _a.asNavbarItems, asNavbarItems = _b === void 0 ? false : _b, manualUrl = _a.manualUrl, onGuidedTour = _a.onGuidedTour, track = _a.track;
    var Link = useLegoland().Link;
    var items = [];
    if (manualUrl) {
        items.push({
            label: "User guide",
            props: {
                as: Link,
                href: manualUrl,
                onClick: function () {
                    track("page_click", {
                        specificProps: {
                            component_name: "header",
                            component_sub_name: "user-guides-button",
                        },
                    });
                },
                target: "_blank",
            },
        });
    }
    if (onGuidedTour) {
        items.push({
            label: "Guided tour",
            props: {
                onClick: function () {
                    track("page_click", {
                        specificProps: {
                            component_name: "header",
                            component_sub_name: "user-guides-tour-button",
                        },
                    });
                    onGuidedTour();
                },
            },
        });
    }
    if (asNavbarItems) {
        return (React.createElement(React.Fragment, null, items.map(function (item) { return (React.createElement(NavbarMenuItem, { key: item.label },
            React.createElement(NavbarMenuLink, __assign({}, item.props), item.label))); })));
    }
    else if (items.length === 1) {
        return (React.createElement(TooltipOnHover, { content: items[0].label, placement: "bottom", size: "s", variant: "inverted" },
            React.createElement(IconButton, __assign({ className: className }, items[0].props),
                React.createElement(GuideIcon, null))));
    }
    else if (items.length > 1) {
        return React.createElement(ButtonWithMenu, { items: items });
    }
    else {
        return null;
    }
};
//# sourceMappingURL=GuideButton.js.map